<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ded"><em class="i">T</em><em class="i">o all the right-thinking men I have known,</em> <br/><em class="i">and the libertines who keep them in line.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HouseDivided-6.vue?32d974b5